export const ENABLE_INTERNAL_NAVIGATION =
  process.env.REACT_APP_ENABLE_INTERNAL_NAVIGATION === 'true';
export const ENABLE_DASHBOARD_LAST_UPDATE =
  process.env.REACT_APP_ENABLE_DASHBOARD_LAST_UPDATE === 'true';
